import React from "react"
import Input from "../../components/UI/Input/Input"
import classes from "./Controls.module.css"
import Select from "react-select"
import { drink_order, SkillIDs, SkillIDsRev, MappingDrinkBrand, default_multi_style } from "../../Utils"
import { useTranslation } from "react-i18next"

const ControlsSearch = props => {
    const { t } = useTranslation()

    const get_drink_labels = () => {
        const res = []
        for (const drink of drink_order) {
            res.push({
                value: MappingDrinkBrand[drink],
                label: t("translation:CommonMsg.Lobby.LobbyFoodName." + drink),
            })
        }
        return res
    }
    const drinkLabels = get_drink_labels()
    const ms = default_multi_style()

    return (
        <div className={classes.Wrapper}>
            <Input title={t("misc:Checker.CurrentSeed")} changed={props.seedValidator} val={props.currentSeed} />
            <Input
                type="number"
                title={t("misc:Checker.StartSlot")}
                val={props.currentStartFrame}
                changed={props.startValidator}
            />
            <Input
                type="number"
                title={t("misc:Checker.MaxNumberOfSlots")}
                val={props.currentNumberOfFrames}
                changed={props.numberValidator}
            />

            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("misc:Checker.AllowedDrinks")}</span>
                <div className={classes.DrinkSlots}>
                    <Select
                        defaultValue={drinkLabels}
                        isMulti
                        name="drinks"
                        options={drinkLabels}
                        styles={ms}
                        onChange={props.handleDrinkSelection}
                        value={props.selectedDrinks}
                        formatOptionLabel={elem => {
                            const url = `https://leanny.github.io/splat3/images/skill/${elem.value}.png`
                            return (
                                <div className={classes.Entry} key={elem.value}>
                                    {elem.value !== "None" ? (
                                        <img src={url} alt={elem.label} className={classes.Ability} />
                                    ) : (
                                        ""
                                    )}
                                    <span className={classes.Gap}> {elem.label}</span>
                                </div>
                            )
                        }}
                    />
                </div>
            </div>
            <div className={classes.InputWrapper}>
                <span className={classes.Title}>{t("misc:Checker.Target")}</span>
                <div className={classes.Input}>
                    <div style={props.showAbilityControls === 0 ? { border: "2px solid var(--border-color)" } : null}>
                        <img
                            src={`https://leanny.github.io/splat3/images/skill/${
                                SkillIDsRev[props.selectedAbilities[0]]
                            }.png`}
                            width={32}
                            className={classes.Ability}
                            alt={SkillIDsRev[props.selectedAbilities[0]]}
                            onClick={() => props.abilityControlChange(0)}
                        />
                    </div>
                    <div style={props.showAbilityControls === 1 ? { border: "2px solid var(--border-color)" } : null}>
                        <img
                            src={`https://leanny.github.io/splat3/images/skill/${
                                SkillIDsRev[props.selectedAbilities[1]]
                            }.png`}
                            width={32}
                            className={classes.Ability}
                            alt={SkillIDsRev[props.selectedAbilities[1]]}
                            onClick={() => props.abilityControlChange(1)}
                        />
                    </div>
                    <div style={props.showAbilityControls === 2 ? { border: "2px solid var(--border-color)" } : null}>
                        <img
                            src={`https://leanny.github.io/splat3/images/skill/${
                                SkillIDsRev[props.selectedAbilities[2]]
                            }.png`}
                            width={32}
                            className={classes.Ability}
                            alt={SkillIDsRev[props.selectedAbilities[2]]}
                            onClick={() => props.abilityControlChange(2)}
                        />
                    </div>
                </div>
            </div>

            {props.showAbilityControls >= 0 ? (
                <div className={classes.extraZone}>
                    <div className={classes.abilitiyList}>
                        {Object.keys(SkillIDs)
                            .filter(elem => SkillIDs[elem] < 100 || SkillIDs[elem] === 255)
                            .map((ability, idx) => {
                                return (
                                    <div
                                        key={idx}
                                        onClick={() =>
                                            props.abilityChange(props.showAbilityControls, SkillIDs[ability])
                                        }
                                    >
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${ability}.png`}
                                            className={classes.Ability}
                                            alt={ability}
                                        />
                                    </div>
                                )
                            })}
                    </div>
                </div>
            ) : null}

            <Input
                type="checkbox"
                title={t("misc:Checker.AllowChunks")}
                val={props.allowChunks}
                changed={props.allowChunksHandler}
            />

            <Input
                type="checkbox"
                title={t("misc:Checker.FixedOrder")}
                val={props.fixedOrder}
                changed={props.fixedOrderHandler}
            />

            <div>
                <button className={classes.Button} onClick={props.calculateResults}>
                    {t("misc:Checker.ButtonFindResult")}
                </button>
            </div>
        </div>
    )
}

export default React.memo(ControlsSearch)
